import {
  buildAssessmentActionCreatePath,
  buildAssessmentDeletePath,
  buildAssessmentEntriesForMethodForRelationCreatePath,
  buildAssessmentForSchoolCreatePath,
  buildAssessmentPartialUpdatePath,
  buildSelectListDeletePath,
  buildSelectListDetailPath,
  buildSelectListForSchoolCreatePath,
  buildSelectListForSchoolListPath,
  buildSelectListPartialUpdatePath,
} from '../../generated/schooly-api-v1/api-paths';
import {
  buildExportMarkbookApiV2ExportMarkbookForSchoolSchoolIdGetPath,
  buildGetAggregatedAssessmentsApiV2AssessmentForSchoolSchoolIdAggregateGetPath,
  buildGetAssessmentEntriesForProfileOverviewApiV2AssessmentForProfileProfileIdOverviewGetPath,
  buildGetAssessmentEntriesForSchoolApiV2AssessmentEntriesForSchoolSchoolIdGetPath,
  buildGetAssessmentsAverageApiV2AssessmentForSchoolSchoolIdAverageGetPath,
  buildGetAssessmentsForProfileApiV2AssessmentForProfileProfileIdGetPath,
  buildGetAssessmentsListApiV2AssessmentForSchoolSchoolIdGetPath,
  buildGetMarkbookApiV2AssessmentMarkbookForSchoolSchoolIdGetPath,
  buildGetSingleAssessmentApiV2AssessmentAssessmentIdGetPath,
} from '../../generated/schooly-api-v2';

// Paths (aliased builders for convenient imports)
export const createAssessmentPath = buildAssessmentForSchoolCreatePath;
export const deleteAssessmentPath = buildAssessmentDeletePath;
export const assessmentActionPath = buildAssessmentActionCreatePath;
export const editAssessmentPath = buildAssessmentPartialUpdatePath;
export const entriesForMethodForRelationPath = buildAssessmentEntriesForMethodForRelationCreatePath;
export const createGradePath = buildSelectListForSchoolCreatePath;
export const getGradesPath = buildSelectListForSchoolListPath;
export const updateGradePath = buildSelectListPartialUpdatePath;
export const deleteGradePath = buildSelectListDeletePath;
export const getSingleGradePath = buildSelectListDetailPath;
export const getAssessmentsListPath =
  buildGetAssessmentsListApiV2AssessmentForSchoolSchoolIdGetPath;
export const getSingleAssessmentPath = buildGetSingleAssessmentApiV2AssessmentAssessmentIdGetPath;
export const getAssessmentEntriesForProfileOverviewPath =
  buildGetAssessmentEntriesForProfileOverviewApiV2AssessmentForProfileProfileIdOverviewGetPath;
export const getAssessmentEntriesForSchoolPath =
  buildGetAssessmentEntriesForSchoolApiV2AssessmentEntriesForSchoolSchoolIdGetPath;
export const getAssessmentsForProfilePath =
  buildGetAssessmentsForProfileApiV2AssessmentForProfileProfileIdGetPath;
export const getMarkbookPath = buildGetMarkbookApiV2AssessmentMarkbookForSchoolSchoolIdGetPath;
export const exportMarkbookPath = buildExportMarkbookApiV2ExportMarkbookForSchoolSchoolIdGetPath;
export const getAggregatedAssessmentsPath =
  buildGetAggregatedAssessmentsApiV2AssessmentForSchoolSchoolIdAggregateGetPath;
export const buildAssessmentsAveragePath =
  buildGetAssessmentsAverageApiV2AssessmentForSchoolSchoolIdAverageGetPath;
